import { css, styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { RichMarkdownDS } from '../../sharedStyles/textStyles';
const dynamicStyledContainerIsExpanded = ({ isExpanded, hoveredHeight }) =>
  isExpanded && hoveredHeight
    ? `
        max-height: unset;
      `
    : `
        max-height: ${hoveredHeight}px;
      `;

export const StyledContainer = styled('div')(
  ({ theme, isExpanded, hoveredHeight }) => `
  overflow: hidden;
  position: relative;
  z-index: 2;

  ${dynamicStyledContainerIsExpanded({ isExpanded, hoveredHeight })};
  
  margin: 0 ${theme.DS_spacing(['md'])};
  padding: 0 1px;
  
  ${theme.breakpoints.up(['md'])} {
     margin: 0 ${theme.DS_spacing(['lgx'])};
  }

  ${theme.breakpoints.up(['lg'])} {
    width: 100%;
    margin: auto;
    max-width: 840px;
  }
  
   ${RichMarkdownDS({ theme })};
  
`,
);

export const StyledRichText = styled('div')(
  ({ theme }) => `
  ${RichMarkdownDS({ theme })};
  ul {
   list-style: inherit;
  }
  li > p {
   margin: 0;
  }
`,
);

export const StyledSubHeading = styled(Typography)(
  ({ theme }) => `
  color: ${theme.DS_palette.text.secondary};
  text-transform: uppercase;
  
  + div > :first-child, + :is(div, h1, h2, h3, h4, h5, h6, p)  {
  margin-top: ${theme.DS_spacing(['xs'])};
  }
`,
);

const dynamicHoverGradient = ({ theme, isChildren }) =>
  isChildren &&
  css`
    ${theme.breakpoints.up(['md'])} {
      width: 100%;
      margin: auto;
    }
  `;
export const HoverGradient = styled('div')`
  position: absolute;
  width: 100vw;
  height: 250px;
  bottom: 0;
  left: 0;
  margin-left: calc(50% - 50vw);

  ${dynamicHoverGradient};

  background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
`;
